<template>
	<el-dialog :title="isEdit ? '编辑表决' : '新建表决'" :visible.sync="voteDialogVisible" append-to-body width="640px" center
		v-if="voteDialogVisible" custom-class="voteDialog" :before-close="cancel" :close-on-click-modal="false"
		:close-on-press-escape="false">
		<el-form :model="voteForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
			<el-form-item label-width="100px" label="表决项名" prop="name">
				<el-input v-model="voteForm.name" placeholder="请输入表决项名"></el-input>
			</el-form-item>
			<el-form-item label-width="100px" label="内容简介" prop="content">
				<el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="voteForm.content"> </el-input>
			</el-form-item>
			<template v-if="isFlag">
				<el-form-item label="参与表决的组别" prop="groups" label-width="120px">
					<el-checkbox-group v-model="voteForm.groups">
						<el-checkbox v-for="item in groupData" :key="item.id" :label="item.id" :value="item.id">
							{{ item.name }}
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<div class="" style="border-bottom: 1px solid rgba(166,166,166,0.16);margin-bottom: 20px;">

				</div>
				<el-form-item label="投票规则">
					<el-radio-group @change="radioGroupChange" v-model="voteForm.voteType">
						<el-radio label="SINGLE_CHOICE">同意&反对</el-radio>
						<el-radio label="MULTIPLE_CHOICE">几选几</el-radio>
						<el-radio label="ELECT">选举</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="voteForm.voteType === 'MULTIPLE_CHOICE'">
					<div class="peopleChoice">
						<div class="peopleNumber">
							<div class="peopleChoice-left">
								<span class="num">代表项</span>
								<el-input-number v-model="voteForm.numerator" :min="1" label="描述文字"></el-input-number>
							</div>
							<div class="peopleChoice-left">
								<span class="num">候选项</span>
								<el-input-number v-model="voteForm.denominator" :min="2" :max="20" label="描述文字">
								</el-input-number>
							</div>
						</div>
						<CandidateTag :dynamicTags="dynamicTags" :numerator="voteForm.numerator"
							:denominator="voteForm.denominator" />
					</div>
				</el-form-item>
				<el-form-item v-if="voteForm.voteType === 'ELECT'">
					<div class="peopleChoice">
						<div class="peopleNumber">
							<div class="peopleChoice-left">
								<span class="num">代表项</span>
								<el-input-number v-model="voteForm.numerator" :min="0" label="描述文字"></el-input-number>
							</div>
							<div class="peopleChoice-left" style="position: relative;margin-left: 103px;">
								<!-- <span class="num">候选项</span>
                                <el-input-number v-model="voteForm.denominator" :min="2" :max="20" label="描述文字"></el-input-number> -->
								<el-button class="button-new-tag" size="small" @click="addCandidateItemClick">+ 添加候选项
								</el-button>
								<div v-if="dialogVisible" class=""
									style="position: absolute;right: -254px;top: 0px;padding: 15px;border-radius: 5px;background-color: #FFFFFF;border: 1px solid #CCCCCC;">
									<div class="" style="display: flex;justify-content: flex-end;margin-bottom: 5px;">
										<i @click="dialogVisibleClose" class="el-icon-close"
											style="font-size: 18px;"></i>
									</div>
									<div class=""
										style="border-bottom: 2px solid #2766ff;margin-bottom: 10px;padding-bottom: 10px;">
										<el-input v-model="keyword" placeholder="请输入搜索关键字" prefix-icon="el-icon-search">
										</el-input>
									</div>
									<div class="" style="width: 100%;height: 350px;overflow-y: auto;">
										<div @click="selectCreatorUserList(item)" class=""
											v-for="item in creatorUserLists">
											<el-button
												style="width: 190px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis;text-align: left;"
												type="text">{{item.name}}</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class=""
							style="width: 95%;border: 1px solid #CCCCCC;background-color: #FFFFFF;border-radius: 5px;height: 150px;overflow-y: auto;margin-top: 10px;padding: 10px;">
							<div class="" style="display: flex;flex-flow: wrap;">
								<div class="" v-for="(item,index) in selectList"
									style="border: 1px solid #CCCCCC;margin-right: 10px;display: flex;align-items: center;border-radius: 5px;padding: 2px 10px;margin-bottom: 10px;">
									<div class="">
										{{item.name}}
									</div>
									<div class="" style="margin-left: 10px;">
										<i @click="deleteSelectList(index)" class="el-icon-close"
											style="font-size: 14px;"></i>
									</div>
								</div>
							</div>
						</div>
						<!-- <CandidateTag :dynamicTags="dynamicTags" :numerator="voteForm.numerator" :denominator="voteForm.denominator" /> -->
					</div>
				</el-form-item>

				<!-- <el-form-item
                    label="参与表决的组别"
                    v-else
                    class="radio"
                    prop="radio"
                    :class="voteForm.voteType === 'SINGLE_CHOICE' ? '' : 'mt30'"
                >
                    <el-radio-group v-model="voteForm.radio">
                        <el-radio v-for="item in groupData" :key="item.id" :label="item.id">{{ item.name }}</el-radio>
                    </el-radio-group>
                </el-form-item> -->
				<el-form-item v-if="voteForm.voteType === 'ELECT'" label="是否开启参会人自由推荐">
					<el-switch active-text="是" inactive-text="否" v-model="voteForm.enableRecommend" :disabled="switchDisabled"
						></el-switch>
						<!-- :disabled="switchDisabled" -->
				</el-form-item>
				<el-form-item label="人数计算分母统计规则">
					<el-radio-group v-model="voteForm.calculateRule">
						<el-radio :label="1">实际投票人数 + 签到未投票人数</el-radio>
						<el-radio :label="0">实际投票人数</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否显示表决结果占比" prop="showProportion">
					<el-switch active-text="是" inactive-text="否" v-model="voteForm.showProportion"></el-switch>
				</el-form-item>
				<el-form-item label="是否允许多笔债权分别投票" prop="allowPartVote">
					<el-switch active-text="是" inactive-text="否" v-model="voteForm.allowPartVote"></el-switch>
				</el-form-item>
				<el-form-item label="是否允许弃权" prop="allowWaive">
					<el-switch active-text="是" inactive-text="否" v-model="voteForm.allowWaive"></el-switch>
				</el-form-item>
				<el-form-item v-if="voteForm.voteType == 'SINGLE_CHOICE'" label="是否需要填写反对理由" prop="allowWaive">
					<div class="flex align-center">
						<div class="" style="height: 33px;">
							<el-switch active-text="是" inactive-text="否" v-model="voteForm.isReason"></el-switch>
						</div>
						<div v-if="voteForm.isReason" class="" style="margin-left: 10px;">
							<span class="num">理由字数不少于</span>
							<el-input-number style="margin-left: 5px;margin-right: 5px;" v-model="voteForm.reasonWordNum" :min="1" label="描述文字"></el-input-number>
							<span class="num">字</span>
							
						</div>
					</div>
				</el-form-item>
			</template>
		</el-form>

		<span slot="footer" class="dialog-footer">
			<el-button class="operation" :loading="deLoading" v-if="isEdit && !voteForm.began" @click="deleteVote">删除表决
			</el-button>
			<el-tooltip placement="top" v-if="isEdit && voteForm.began">
				<div slot="content">表决进行中，不能执行删除操作</div>
				<el-button style="width: 120px;" class="operation" :loading="deLoading">删除表决</el-button>
			</el-tooltip>
			<el-button style="width: 120px;" @click="cancel">取 消</el-button>
			<!-- style="background:#de4d2a !important" -->
			<el-button style="width: 120px;" type="primary" @click="addVote('ruleForm')" :loading="loading">确 定
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
	let that;
	import CandidateTag from '@/components/candidateTag';
	import {
		addVote,
		editVoteInfo,
		editVoteLocalInfo,
		deleteVote
	} from '@/serve/userGrouping';
	import {
		getCreatorUserList,
		getCreatorCount
	} from '@/serve/user';
	export default {
		components: {
			CandidateTag
		},
		props: {
			isFlag: Boolean,
			voteForm: Object,
			meetingId: String,
			isEdit: Boolean,
			voteDialogVisible: Boolean,
			groupData: Array, // 分组组别
			switchDisabled:Boolean,
		},
		watch: {
			'voteForm.voteType': {
				handler(newVal) {
					console.log("newVal",newVal)
					if (newVal === 'MULTIPLE_CHOICE') {
						// this.voteForm.numerator = 1;
						if(this.voteForm.options[0].name ==null){
							this.dynamicTags = this.voteForm.options;
						}
					} else if (newVal === 'ELECT') {
						// this.voteForm.numerator = 0;
						if(this.voteForm.options[0].name !=null ){
							this.selectList = this.voteForm.options;
						}
						console.log("selectList", this.selectList)
					}
					console.log("初始3")
				}

			},
			keyword(e) {
				console.log("e", e)
				// this.getCreatorUserLists();
				this.creatorUserLists = [];
				this.getCreatorUserLists();
			},
		},
		created(){
			that = this;
			if (this.voteForm.voteType === 'MULTIPLE_CHOICE') {
				if(this.voteForm.options[0].name ==null){
					this.dynamicTags = this.voteForm.options;
				}
			} else if (this.voteForm.voteType === 'ELECT') {
				if(this.voteForm.options[0].name !=null ){
					this.selectList = this.voteForm.options;
				}
			}
			 console.log(" that.voteForm.options",  this.voteForm.options);
							
			console.log("selectList", that.selectList);
		},
		data() {
			return {
				loading: false,
				deLoading: false,
				dialogVisible: false,
				dynamicTags: [],
				rules: {
					name: [{
						required: true,
						message: '请选择表决项名',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '请填写内容简介',
						trigger: 'blur'
					}],
					groups: [{
						type: 'array',
						required: true,
						message: '请至少选择一个表决组别',
						trigger: 'change'
					}],
					radio: [{
						required: true,
						message: '请选择一个表决组别',
						trigger: 'change'
					}]
				},
				creatorUserList: [],
				creatorUserLists: [],
				keyword: '',
				selectList: [],
				viewHeight: 0, // 可视区域的高度
				startIndex: 0, // 开始索引
				endIndex: 0, // 结束索引
				transformOffset: 0, // 列表的偏移量
				page: 0,
				total: 0,
				// switchDisabled: false,
			};
		},
		
		methods: {
			radioGroupChange(e){
				console.log("e",e)
				this.voteForm.options = [];
				if (this.voteForm.voteType === 'MULTIPLE_CHOICE') {
					this.voteForm.numerator = 1;
					if(this.voteForm.options[0].name ==null){
						this.dynamicTags = this.voteForm.options;
					}
				} else if (this.voteForm.voteType === 'ELECT') {
					this.voteForm.numerator = 0;
					if(this.voteForm.options[0].name !=null ){
						this.selectList = this.voteForm.options;
					}
					console.log("selectList", this.selectList)
				}
				
			},
			filteredArray() {
				this.creatorUserLists = this.creatorUserList.filter(itemA => {
					return !this.selectList.some(itemB => itemB.name === itemA.name)
				})
			},
			deleteSelectList(index) {
				this.selectList.splice(index, 1);
				this.filteredArray();
				// if (this.total <= this.selectList.length) {
				// 	this.switchDisabled = true;
				// 	this.voteForm.enableRecommend = false;
				// } else {
				// 	this.switchDisabled = false;
				// }
				if(this.selectList.length == 0){
					this.switchDisabled = true;
					this.voteForm.enableRecommend = true;
				}else{
					if(this.creatorUserLists.length == 0){
						this.voteForm.enableRecommend = false;
						this.switchDisabled = true;
					}else{
						this.switchDisabled = false;
					}
				}
				
			},
			selectCreatorUserList(item, index) {
				console.log("item",item)
				this.selectList.push(item);
				// if (this.total <= this.selectList.length) {
				// 	this.switchDisabled = true;
				// 	this.voteForm.enableRecommend = false;
				// } else {
				// 	this.switchDisabled = false;
				// }
				this.filteredArray();
				if(this.creatorUserLists.length == 0){
					this.voteForm.enableRecommend = false;
					this.switchDisabled = true;
				}else{
					this.switchDisabled = false;
				}
			},
			getCreatorUserLists() {
				getCreatorCount(this.meetingId, {
					admin: false,
					attend: true,
					// name: this.keyword,
				}).then(resData => {
					this.total = resData;
					getCreatorUserList(this.meetingId, {
							admin: false,
							attend: true,
							name: this.keyword,
							page: 0,
							rows: resData
						})
						.then(res => {
							let list = [];
							for (let i in res) {
								list.push({
									name: res[i].name + res[i].idNumber,
									userId: res[i].userId
								});
							}
							this.creatorUserList = list;
							this.filteredArray();
							// if(this.keyword == ''){

							// }else{
							// 	this.filtrate();
							// }
							setTimeout(() => {
								// 俩秒之后让模块消失

							}, 2000);

						})
						.catch(err => {
							this.loading = false;
							this.$message.error('获取列表失败');
						});
				});


			},
			addCandidateItemClick() {
				this.dialogVisible = !this.dialogVisible;
				if (this.dialogVisible) {
					// this.creatorUserList = [];
					if (this.creatorUserList.length == '0') {
						this.getCreatorUserLists();
					}

				} else {
					this.dialogVisibleClose();
				}
			},
			dialogVisibleClose() {
				this.keyword = '';
				this.dialogVisible = false;
				this.creatorUserLists = [];
				this.creatorUserList = [];
				this.dynamicTags = [];

			},
			cancel() {
				this.dialogVisibleClose();
				this.selectList = [];
				this.$emit('cancel');
			},
			getSuccessResult() {
				this.dynamicTags = [];
				this.loading = false;
				this.cancel();
				this.$emit('refresh');
			},
			getFailResult(err) {
				this.loading = false;
				this.$message.error(err.data.message);
			},
			// 删除表决
			deleteVote() {
				this.$confirm('此操作将删除该表决, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: 'del-model',
					type: 'warning'
				}).then(() => {
					this.deLoading = true;
					deleteVote(this.voteForm.id)
						.then(() => {
							this.deLoading = false;
							this.$message.success('删除成功');
							this.getSuccessResult();
						})
						.catch(err => {
							this.getFailResult();
						});
				});
			},
			// 新建表决/编辑表决
			addVote(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						let groups = [];
						this.loading = true;
						this.voteForm.subjectId = this.meetingId;
						if (this.voteForm.voteType === 'SINGLE_CHOICE') {
							// 是否允许弃权
							let arr = [];
							if (this.voteForm.allowWaive) {
								arr = ['同意', '反对', '弃权'];
							} else {
								arr = ['同意', '反对'];
							}
							this.voteForm.options = arr.map(item => {
								return {
									name: item
								};
							});
							groups = this.voteForm.groups.map(item => {
								return {
									groupId: item
								};
							});
						} else if (this.voteForm.voteType === 'MULTIPLE_CHOICE') {

							if (this.dynamicTags.length != this.voteForm.denominator) {
								this.loading = false;
								return this.$message.error('候选项不足');
							}
							groups = this.voteForm.groups.map(item => {
								return {
									groupId: item
								};
							});
							if (this.voteForm.allowWaive) {
								this.voteForm.options = ['弃权', ...this.dynamicTags];
							} else {
								this.voteForm.options = [...this.dynamicTags];
							}
							this.voteForm.options = this.voteForm.options.map(item => {
								return {
									name: item
								};
							});
						} else if (this.voteForm.voteType === 'ELECT') {
							if(this.selectList.length>0 && this.voteForm.numerator == 0){
								this.loading = false;
								return this.$message.error('代表项不能为零！');
							}
							if (this.selectList.length < this.voteForm.numerator) {
								this.loading = false;
								return this.$message.error('候选项不足');
							}
							// for (let i = 0; i < this.voteForm.groups.length; i++) {
							// 	this.voteForm.groups[i]
							// 	for (let j = 0; j < this.groupData.length; j++) {
							// 		if(this.voteForm.groups[i] == this.groupData[j].id){
							// 			groups.push({
							// 				groupId
							// 			})
							// 		}
							// 	}
							// }
							console.log("this.voteForm.groups",this.voteForm.groups)
							this.voteForm.denominator = this.selectList.length;
							groups = this.voteForm.groups.map(item => {
								return {
									groupId: item,
									// id:'',
									// name:'',
									// voteId:'',
								};
							});
							console.log("groups",groups)
							this.voteForm.options = this.selectList;
							if (this.voteForm.allowWaive) {
								this.voteForm.options = [{
									name: '弃权'
								}, ...this.selectList];
							} else {
								this.voteForm.options = [...this.selectList];
							}
						}
						if (this.isEdit) {
							if (this.isFlag) {
								editVoteInfo(this.voteForm.id, {
										...this.voteForm,
										groups
									})
									.then(() => {
										this.getSuccessResult();
										this.$message.success('编辑表决成功');
									})
									.catch(err => {
										this.getFailResult(err);
									});
							} else {
								editVoteLocalInfo(this.voteForm.id, {
										name: this.voteForm.name,
										content: this.voteForm.content
									})
									.then(() => {
										this.getSuccessResult();
										this.$message.success('编辑表决成功');
									})
									.catch(err => {
										this.getFailResult(err);
									});
							}
						} else {
							console.log("voteForm", this.voteForm)
							console.log("groups", groups)
							// return
							addVote({
									...this.voteForm,
									groups
								})
								.then(() => {
									this.getSuccessResult();
									this.$message.success('新建表决成功');
								})
								.catch(err => {
									this.getFailResult(err);
								});
						}
					}
				});
			}
		}
	};
</script>
